import DomainEnrollOptionFull from './components/DomainEnrollOptionFull';
import { Option } from 'owa-options-core';
import * as React from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import store from './store/store';
import { HMPlusBit } from 'owa-domain-connect';
import SubscriberType from './contracts/subscriberType';

let DomainEnrollOption: Option = {
    key: 'domainenroll',
    titleStringKey: 'options_premiumSubOption_PersonalEmail',
    searchTermsStringKey: 'options_premiumSubOption_PersonalEmail',
    hideTitleInFullOptions: false,
    fullOptionFormSettings: {
        render: () => <DomainEnrollOptionFull />,
        isDirty: () => false,
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: () => true,
    },
    isHidden: isOptionHidden,
};

function isOptionHidden(): boolean {
    var isHidden = true;

    if (store.subscriberType == SubscriberType.Primary && !store.domainState.isDomainCreated) {
        isHidden = false;
    } else if (
        store.subscriberType == SubscriberType.Secondary &&
        !store.userInfo.isProsumerConsumerMailbox &&
        (store.domainState.isDomainCreated || store.domainState.isValid)
    ) {
        isHidden = false;
    }

    return (
        !isFeatureEnabled('auth-domainConnect') ||
        !isFeatureEnabled('auth-PremiumDashboardApril') ||
        !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
        (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) == HMPlusBit ||
        isHidden
    );
}

export default DomainEnrollOption;
